import { useEffect, useState } from 'react';
import PrometheusStatService from '../../services/PrometheusStatService';
import PrometheusPostgreSqlDeleteStats from '../../types/PrometheusPostgreSqlDeleteStats';

export default function usePrometheusPostgreSqlDeleteStats(
    uuid: string,
    host_uuid: string,
    from?: string,
    to?: string
) {
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const [stats, setStats] = useState<
        PrometheusPostgreSqlDeleteStats[] | undefined
    >(undefined);

    const load = async () => {
        if (uuid) {
            try {
                let details = await PrometheusStatService.getPostgreSqlDelete(
                    uuid,
                    host_uuid,
                    from,
                    to
                );

                setStats(
                    details.map(
                        (d: any) => new PrometheusPostgreSqlDeleteStats(d)
                    )
                );
                setError(null);
            } catch (e: any) {
                setError(e);
            }
            setUpdating(false);
            setLoading(false);
        }
    };

    const refresh = () => {
        setUpdating(true);
        load();
    };

    // get deployments for the given user
    useEffect(() => {
        const init = async () => {
            setLoading(true);
            await load();
        };

        init();
    }, [uuid, host_uuid, from, to]);

    return { stats, refresh, loading, updating, error };
}
